import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import supabase from 'sdk/api';
import 'swiper/css';
import { useSwiper, useSwiperSlide } from 'swiper/react';
import AssetDetails from './AssetDetails';
import Comments from './Comments';
import styles from './Feed.module.scss';
import Post from './Post';
import { useActions } from 'store/useActions';
import { Dispatch, SetStateAction } from 'react';
import { PostFilter } from 'sdk/hooks/useAllPosts';

type PostBlockProps = {
  data: any;
  refresh?: () => Promise<any>;
  feed?: string;
  category?: string;
  setCategoryFilter: React.Dispatch<React.SetStateAction<string>>;
  videoMuted: boolean;
  onVideoMuted?: React.Dispatch<React.SetStateAction<boolean>>;
  onNextPage?: () => void;
  onPrevPage?: () => void;
  onSaveCurrentState?: () => void;
  onSetCurrentSlide: React.Dispatch<React.SetStateAction<number>>;
  idx: number;
  isActive: boolean;
  targetPostId?: string;
};

function PostBlock(props: PostBlockProps) {
  const [commentsVisible, setCommentsVisible] = useState(false);
  const [activeAsset, setActiveAsset] = useState<any>();
  const swiperSlide = useSwiperSlide();
  const swiper = useSwiper();
  const [lastPrice, setLastPrice] = useState(0);
  const [myCommentCount, setMyCommentCount] = useState(0);
  const { setIsButtonMenuVisible } = useActions();

  const handleUpdate = data => {
    setLastPrice(data?.new?.latest_price?.price || 0);
  };

  useEffect(() => {
    setLastPrice(activeAsset?.latest_price?.price || 0);
  }, [activeAsset?.latest_price?.price]);

  useEffect(() => {
    let channel: any;
    if (activeAsset?.id) {
      channel = supabase
        .channel('supabase_realtime')
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'assets',
            filter: `id=eq.${activeAsset?.id}`,
          },
          handleUpdate,
        )
        .subscribe();
    }
    return () => {
      if (channel) channel.unsubscribe();
    };
  }, [activeAsset?.id]);

  useEffect(() => {
    if (!swiperSlide.isActive) {
      setCommentsVisible(false);
      setActiveAsset(null);
    } else {
      props?.onSetCurrentSlide(props?.idx);
    }

    if (props?.idx === 0 && props?.onPrevPage) {
      props?.onPrevPage();
    }
    // eslint-disable-next-line no-unsafe-optional-chaining
    if (
      swiperSlide.isActive &&
      props?.idx >= Number(swiper?.slides?.length) - 3 &&
      props?.idx !== 0 &&
      props?.onNextPage
    ) {
      // eslint-disable-next-line no-unsafe-optional-chaining
      props?.onNextPage();
    } // @ts-ignore
  }, [swiperSlide.isActive]);

  const setPanelSize = (ref: HTMLDivElement) => {
    const panelInnerElement = ref;
    if (panelInnerElement) {
      const containerElement = ref.parentElement?.parentElement;
      panelInnerElement.style.height = `${containerElement?.offsetHeight}px`;
      if (window.innerWidth <= 1400) {
        panelInnerElement.style.width = `${containerElement?.offsetWidth}px`;
      } else {
        panelInnerElement.style.width = '100%';
      }
    }
  };

  const handleShowComments = () => {
    setCommentsVisible(true);
    setIsButtonMenuVisible(false)
    if (window.innerWidth <= 1400) {
      setActiveAsset(null);
    }
  };

  const handleSetActiveAsset = asset => {
    setActiveAsset(asset);
    if (window.innerWidth <= 1400) {
      setCommentsVisible(false);
    }
  };

  const panelClasses = clsx(
    styles.panel,
    (activeAsset || commentsVisible) && styles.openChatOrAssets,
  );

  React.useEffect(() => {
    if (!commentsVisible) setIsButtonMenuVisible(true)
  },[commentsVisible])

  return (
    <div className={panelClasses}>
      <div
        className={styles.panelInner}
        ref={refPanelInner => {
          if (refPanelInner) {
            setPanelSize(refPanelInner);

            window.addEventListener('resize', () => {
              setPanelSize(refPanelInner);
            });
          }
        }}
      >
        {/* {activeAsset && (
          <AssetDetails
            className={clsx(styles.panelSection)}
            activeAsset={activeAsset.id}
            setActiveAsset={setActiveAsset}
            onSaveCurrentState={props?.onSaveCurrentState}
          />
        ) } */}
        <Post
          {...props}
          hasCategories
          hasComment
          className={styles.panelSection}
          lastPrice={lastPrice}
          myCommentCount={myCommentCount}
          onShowComments={handleShowComments}
          activeAsset={activeAsset}
          setActiveAsset={asset => handleSetActiveAsset(asset)}
        />
        <Comments
          {...props}
          className={clsx(
            styles.panelSection,
            'swiper-no-swiping',
            !commentsVisible && styles.panelSection_hide,
          )}
          onClose={() => {
            setCommentsVisible(false)
            setIsButtonMenuVisible(true)
          }}
          setMyCommentCount={setMyCommentCount}
          commentsVisible={commentsVisible}
          postId={props?.data?.data?.id}
        />
        <div
          className={styles.mobileModalBackground}
          onClick={() => {
            setCommentsVisible(false);
            setActiveAsset(null);
          }}
        />
      </div>
    </div>
  );
}

export default PostBlock;
